export function shortenCategoryLabel(fullName: string): { label: string; shortened: boolean } {
  if (!fullName) {
    return { label: '', shortened: false }
  }

  const cleaned = fullName.replace(/\bNews\b/gi, '').replace(/\s{2,}/g, ' ').trim()
  const label = cleaned.length > 0 ? cleaned : fullName

  return { label, shortened: label !== fullName }
}
